import styled from 'styled-components';

export const FeaturesContainer = styled.div`
  margin: ${(props) => (props.from !== 'course' ? '0 auto !important' : 'none')};
  padding: 15px 30px;
  background: ${(props) => (props.from === 'USPricing' ? 'linear-gradient(to bottom, #578EFE, #746EE8)' : '#f6f9ff')};
  box-shadow: ${(props) => (props.from === 'USPricing' ? 'rgba(149, 157, 165, 0.2) 0px 8px 24px' : 'none')};
  @media (max-width: 600px) {
    padding: 15px;
  }
`;

export const FeatureDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 15px 0;
  @media (max-width: 600px) {
    margin: 10px 0;
  }
`;

export const FeatureDot = styled.span`
  width: 5px;
  height: 5px;
  background: var(--brandColor);
  border-radius: 15px;
`;

export const FeatureContent = styled.p`
  margin: 0 0 0 6px;
  font-weight: 500 !important;
  font-size: 14px !important;
  strong {
    font-weight: 800 !important;
  }
`;

export const PrimeCourseTag = styled.div`
  font-size: 12px;
  padding: 5px 8px;
  margin: 3px;
  background: #fafafa;
  white-space: nowrap;
`;

export const PremiumTitle = styled.h2`
  text-align: center;
  max-width: 44rem;
  margin: 15px auto;
  @media (max-width: 600px) {
    padding: 0 15px;
  }
`;

export const PremiumSubTitle = styled.p`
  text-align: center;
  margin: 0 auto;
  font-weight: 400 !important;
`;

export const SalePrice = styled.h2`
  font-size: ${(props) => (props.primeOfferStatus ? '20px' : '28px')}!important;
  text-align: center;
  margin: 10px 0;
  font-weight: 400;
`;

export const CrossLine = styled.hr`
  margin: 0 auto;
  width: 114px;
  border: 1px solid #6f6f6f;
  transform: rotate(10deg);
  position: relative;
  top: -15px;
`;
export const NewCrossLine = styled.hr`
  margin: 0 auto;
  width: 114px;
  border: 1px solid ${(props) => props.color};
  transform: rotate(10deg);
  position: relative;
  top: -18px;
`;
export const OfferPrice = styled.h2`
  margin: 10px 0;
  font-size: 36px !important;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const DiscountDiv = styled.div`
  position: absolute;
  top: 22px;
  right: -32px;
  display: block;
  font-size: 14px;
  color: #fff;
  background: var(--highlightColor);
  font-weight: bold;
  padding: 3px 35px;
  box-sizing: border-box;
  transform: rotate(45deg);
  box-shadow: 0px 2px 20px var(--blueShadowColor);
  @media (max-width: 300px) {
    top: 15px;
    font-size: 12px;
  }
`;

export const PromoContent = styled.p`
  padding-top: 10px;
  font-weight: 500 !important;
  font-size: 14px !important;
  strong {
    font-weight: 800 !important;
  }
`;

export const MonthlyText = styled.p`
  font-weight: 600 !important;
  color: #9798a9;
`;

export const CancelText = styled.p`
  font-weight: 400 !important;
  margin-bottom: 0px !important;
  font-size: 14px !important;
  padding-top: 10px;
`;
